import {Base} from "@/api/Base"

export class HolidayList extends Base {
    path = "holiday/list"
}